import upperFirst from 'lodash-es/upperFirst';

import { FromPrice, SFCCGroupPrice, SFCCProductPrice, StandardPrice } from '../models';

const priceFields: (keyof StandardPrice)[] = [
  'productId',
  'familyId',
  'groupId',
  'sku',
  'currency',
  'discountedPrice',
  'discountedPriceWithoutVat',
  'listedPrice',
  'listedPriceWithoutVat',
  'availabilityState',
  'currency',
  'discountPercentage',
  'isDiscounted',
  'offerEndDate',
  'calloutMsg',
  'couponCalloutMessage',
  'lowestPriceInLastMonth',
];
export const mapToStandardPrice = (
  inputPrice: FromPrice | SFCCGroupPrice | SFCCProductPrice
): StandardPrice => {
  const inputPriceObject = inputPrice as Record<string, unknown>;
  return priceFields.reduce((resultPrice, fieldName) => {
    const fromField = `from${upperFirst(fieldName)}`;
    const c_field = `c_${fieldName}`;
    const value =
      inputPriceObject[fieldName] ?? inputPriceObject[fromField] ?? inputPriceObject[c_field];
    return { ...resultPrice, [fieldName]: value };
  }, {});
};
